import { render, staticRenderFns } from "./DeptRoleDataruleModal.vue?vue&type=template&id=54355c19&scoped=true&"
import script from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js&"
export * from "./DeptRoleDataruleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54355c19",
  null
  
)

export default component.exports